const formatPrice = (digits, currency) => (digits ? `${currency}${digits}` : '')

export default formatPrice
